/* Vellisova product configurator: swap strength / pack without a full reload.
   Falls back to the normal link navigation when fetch is unavailable or fails. */
(function () {
  if (!window.fetch || !('DOMParser' in window)) return;
  let controller = null;

  function swap(nextDoc) {
    const current = document.querySelector('section.pdp');
    const next = nextDoc.querySelector('section.pdp');
    if (!current || !next) return false;
    const focusHref = document.activeElement && document.activeElement.getAttribute('href');
    current.replaceWith(next);
    if (nextDoc.title) document.title = nextDoc.title;
    if (focusHref) {
      const again = next.querySelector('a[data-pdp-option][href="' + focusHref.replace(/"/g, '\\"') + '"]');
      if (again) again.focus({ preventScroll: true });
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[data-pdp-option]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (link.getAttribute('aria-current') === 'true') { event.preventDefault(); return; }
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    const configurator = link.closest('.pdp-configurator');
    if (configurator) configurator.setAttribute('aria-busy', 'true');
    if (controller) controller.abort();
    controller = new AbortController();
    const requestUrl = new URL(url);
    if (location.search.indexOf('preview_theme_id') !== -1) {
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) requestUrl.searchParams.set('preview_theme_id', preview);
    }
    fetch(requestUrl.href, { credentials: 'same-origin', signal: controller.signal, headers: { 'X-Requested-With': 'fetch' } })
      .then(function (response) { if (!response.ok) throw new Error('bad status'); return response.text(); })
      .then(function (html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!swap(parsed)) throw new Error('no section');
        const clean = new URL(location.href);
        clean.searchParams.set('variant', url.searchParams.get('variant'));
        history.replaceState(null, '', clean.href);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        location.href = url.href;
      });
  });
})();
